interface NativeSharePayload {
  url: string
  title?: string
  text?: string
}

export const canUseNativeShare = ({ url, title, text }: NativeSharePayload): boolean => {
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
    return false
  }

  const payload: ShareData = { url }
  if (title) payload.title = title
  if (text) payload.text = text

  if (typeof navigator.canShare === 'function') {
    return navigator.canShare(payload)
  }

  return true
}
